/**
 * Vehicle Builder: category click → show pre-rendered collection products in tray Swiper;
 * summary state (Add/Remove/Quantity), Buy Now via /cart/add.js
 * Products are read from script#orpvb-collections-data-{sectionId} (no fetch).
 */
(function () {
  const SECTION_SELECTOR = '[data-orpvb-section]';

  function init(container) {
    const sectionId = container.dataset.orpvbSection;
    const heroEl = container.querySelector('.orpvb-hero-swiper');
    const trayEl = container.querySelector('.orpvb-product-tray-swiper');
    const trayWrapper = trayEl ? trayEl.querySelector('.swiper-wrapper') : null;
    const trayTitleEl = container.querySelector('.orpvb-tray-title') || document.getElementById('orpvb-tray-title-' + sectionId);
    const categoryBtns = container.querySelectorAll('.orpvb-category-btn');
    const summaryList = container.querySelector('.orpvb-build-summary__list');
    const summaryEmpty = container.querySelector('.orpvb-build-summary__empty');
    const summaryTotalEl = container.querySelector('.orpvb-build-summary__total');
    const resetBtn = container.querySelector('.orpvb-build-summary__btn--reset');
    const buyBtn = container.querySelector('.orpvb-build-summary__btn--buy');

    const dataScript = document.getElementById('orpvb-collections-data-' + sectionId);
    const collectionsData = (function () {
      if (!dataScript || !dataScript.textContent) return {};
      try {
        return JSON.parse(dataScript.textContent.trim());
      } catch (_) {
        return {};
      }
    })();
    const productsPerView = dataScript && dataScript.dataset.productsPerView
      ? Math.max(2, parseInt(dataScript.dataset.productsPerView, 10) || 4)
      : 4;

    if (!trayEl || !trayWrapper) return;

    let heroSwiper = null;
    let productTraySwiper = null;
    let buildSummaryItems = [];
    let currentProducts = [];

    function updateSummaryUI() {
      if (!summaryList || !summaryTotalEl) return;
      summaryList.innerHTML = '';
      if (summaryEmpty) summaryEmpty.style.display = buildSummaryItems.length ? 'none' : 'block';

      buildSummaryItems.forEach((item, index) => {
        const li = document.createElement('li');
        li.className = 'orpvb-build-summary__item';
        li.dataset.index = index;
        const variantLine = (item.variantOptionsText && item.variantOptionsText.trim()) ? `<div class="orpvb-build-summary__item-variant">${escapeHtml(item.variantOptionsText)}</div>` : '';
        li.innerHTML = `
          ${item.imageSrc ? `<img class="orpvb-build-summary__item-img" src="${item.imageSrc}" alt="" loading="lazy">` : ''}
          <div class="orpvb-build-summary__item-body">
            <div class="orpvb-build-summary__item-title">${escapeHtml(item.title)}</div>
            ${variantLine}
            <div class="orpvb-build-summary__item-price">${escapeHtml(item.priceFormatted)}</div>
            <div class="orpvb-build-summary__item-actions">
              <button type="button" class="orpvb-build-summary__qty-btn" data-action="qty-minus" aria-label="Decrease">−</button>
              <span class="orpvb-build-summary__qty-value">${item.quantity}</span>
              <button type="button" class="orpvb-build-summary__qty-btn" data-action="qty-plus" aria-label="Increase">+</button>
              <button type="button" class="orpvb-build-summary__remove" data-action="remove">Remove</button>
            </div>
          </div>
        `;
        summaryList.appendChild(li);
      });

      const totalCents = buildSummaryItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
      const totalFormatted = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(totalCents)
        : '$' + (totalCents / 100).toFixed(2);
      summaryTotalEl.textContent = `TOTAL: ${totalFormatted}`;
      summaryTotalEl.style.display = buildSummaryItems.length ? 'block' : 'none';

      updateTraySelectedState();
    }

    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function updateTraySelectedState() {
      const variantIds = new Set(buildSummaryItems.map((i) => String(i.variantId)));
      const productIdsInBuild = new Set(buildSummaryItems.map((i) => String(i.productId)));
      trayEl.querySelectorAll('.orpvb-tray-slide').forEach((slide) => {
        const variantId = slide.dataset.variantId;
        const productId = slide.dataset.productId;
        const selectedByVariant = variantId && variantIds.has(String(variantId));
        const selectedByProduct = productId && productIdsInBuild.has(String(productId));
        slide.classList.toggle('orpvb-tray-slide--selected', selectedByVariant || selectedByProduct);
      });
    }

    function addToBuildSummary(product, imgSrc, variantOptionsText) {
      const optionsText = variantOptionsText != null ? variantOptionsText : (product.variant_options_text || '');
      const existingIndex = buildSummaryItems.findIndex(
        (item) => String(item.variantId) === String(product.variant_id)
      );
      if (existingIndex !== -1) {
        buildSummaryItems[existingIndex].quantity += 1;
      } else {
        buildSummaryItems.push({
          variantId: product.variant_id,
          productId: product.id,
          title: product.title,
          variantOptionsText: optionsText,
          price: product.price,
          priceFormatted: product.price_formatted,
          quantity: 1,
          imageSrc: imgSrc,
        });
      }
      updateSummaryUI();
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    let variantModalProduct = null;
    let variantModalSelectedVariant = null;
    let modalOverlayOriginalParent = null;

    function openVariantModal(product, imgSrc) {
      const overlay = container.querySelector('.orpvb-variant-modal-overlay');
      const modalImage = container.querySelector('.orpvb-variant-modal__image');
      const modalTitle = container.querySelector('.orpvb-variant-modal__title');
      const modalPrice = container.querySelector('.orpvb-variant-modal__price');
      const modalCompare = container.querySelector('.orpvb-variant-modal__price-compare');
      const modalOptions = container.querySelector('.orpvb-variant-modal__options');
      const modalAddBtn = container.querySelector('.orpvb-variant-modal__add-btn');
      if (!overlay || !modalOptions || !modalAddBtn) return;

      variantModalProduct = { product, imgSrc };
      variantModalSelectedVariant = null;

      if (!modalOverlayOriginalParent) {
        modalOverlayOriginalParent = overlay.parentNode;
      }
      document.body.appendChild(overlay);

      if (modalImage) {
        modalImage.src = imgSrc || '';
        modalImage.alt = product.title || '';
      }
      if (modalTitle) modalTitle.textContent = product.title || '';
      setModalPriceCompare(modalPrice, modalCompare, product.price, product.compare_at_price);

      modalOptions.innerHTML = '';
      modalAddBtn.disabled = true;
      modalAddBtn.textContent = 'Add to build';

      const variants = product.variants || [];
      const optionNames = product.options || ['Option 1', 'Option 2', 'Option 3'];
      const optionsMap = {};
      if (variants.length > 0) {
        variants.forEach((v) => {
          ['option1', 'option2', 'option3'].forEach((key, i) => {
            const val = v[key];
            if (val && val !== 'Default Title') {
              const name = optionNames[i] || 'Option ' + (i + 1);
              if (!optionsMap[name]) optionsMap[name] = { position: i, values: new Set() };
              optionsMap[name].values.add(val);
            }
          });
        });
      }

      const sortedOptions = Object.keys(optionsMap)
        .map((name) => ({ name, ...optionsMap[name] }))
        .sort((a, b) => a.position - b.position);
      sortedOptions.forEach(({ name: optionName, position, values }) => {
        const wrap = document.createElement('div');
        wrap.className = 'orpvb-variant-option';
        const label = document.createElement('label');
        label.textContent = optionName;
        label.htmlFor = 'orpvb-option-' + position + '-' + sectionId;
        const select = document.createElement('select');
        select.id = 'orpvb-option-' + position + '-' + sectionId;
        select.className = 'orpvb-variant-select';
        select.dataset.optionPosition = String(position);
        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = 'Select ' + optionName;
        select.appendChild(placeholderOption);
        Array.from(values).forEach((val) => {
          const opt = document.createElement('option');
          opt.value = val;
          opt.textContent = val;
          select.appendChild(opt);
        });
        select.addEventListener('change', () => handleVariantModalChange(product));
        wrap.appendChild(label);
        wrap.appendChild(select);
        modalOptions.appendChild(wrap);
      });

      if (variants.length === 1) {
        variantModalSelectedVariant = variants[0];
        setModalPriceCompare(modalPrice, modalCompare, variants[0].price, variants[0].compare_at_price);
        modalAddBtn.disabled = !variants[0].available;
        modalAddBtn.textContent = variants[0].available ? 'Add to build' : 'Out of stock';
      }

      setTimeout(() => {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }, 10);
    }

    function setModalPriceCompare(modalPrice, modalCompare, price, compareAtPrice) {
      if (modalPrice) modalPrice.textContent = formatMoney(price || 0);
      if (modalCompare) {
        if (compareAtPrice && compareAtPrice > price) {
          modalCompare.textContent = formatMoney(compareAtPrice);
          modalCompare.style.display = '';
        } else {
          modalCompare.textContent = '';
          modalCompare.style.display = 'none';
        }
      }
    }

    function handleVariantModalChange(product) {
      const overlay = document.getElementById('orpvb-variant-modal-overlay-' + sectionId);
      if (!overlay) return;
      const modalOptions = overlay.querySelector('.orpvb-variant-modal__options');
      const modalPrice = overlay.querySelector('.orpvb-variant-modal__price');
      const modalCompare = overlay.querySelector('.orpvb-variant-modal__price-compare');
      const modalAddBtn = overlay.querySelector('.orpvb-variant-modal__add-btn');
      if (!modalOptions || !modalAddBtn) return;

      const selects = Array.from(modalOptions.querySelectorAll('.orpvb-variant-select')).sort((a, b) => {
        const posA = parseInt(a.dataset.optionPosition, 10) || 0;
        const posB = parseInt(b.dataset.optionPosition, 10) || 0;
        return posA - posB;
      });
      const selectedOptions = [];
      let allSelected = true;
      selects.forEach((select) => {
        if (select.value) {
          selectedOptions.push(select.value);
        } else {
          allSelected = false;
        }
      });

      if (allSelected && product.variants && product.variants.length) {
        const variant = product.variants.find((v) => {
          return selectedOptions.every((option, index) => v['option' + (index + 1)] === option);
        });
        if (variant) {
          variantModalSelectedVariant = variant;
          setModalPriceCompare(modalPrice, modalCompare, variant.price, variant.compare_at_price);
          modalAddBtn.disabled = !variant.available;
          modalAddBtn.textContent = variant.available ? 'Add to build' : 'Out of stock';
        }
      } else {
        variantModalSelectedVariant = null;
        modalAddBtn.disabled = true;
        modalAddBtn.textContent = 'Add to build';
      }
    }

    function buildVariantOptionsText(variant) {
      if (!variant) return '';
      const parts = [variant.option1, variant.option2, variant.option3].filter(function (val) {
        return val && val !== 'Default Title';
      });
      return parts.join(' / ');
    }

    function addModalProductToBuild() {
      if (!variantModalSelectedVariant || !variantModalProduct) return;
      if (!variantModalSelectedVariant.available) return;

      const { product, imgSrc } = variantModalProduct;
      const v = variantModalSelectedVariant;
      const img = v.featured_image && v.featured_image.src ? v.featured_image.src : imgSrc;
      const variantOptionsText = buildVariantOptionsText(v);
      const productForSummary = {
        id: product.id,
        title: product.title,
        variant_id: v.id,
        price: v.price,
        price_formatted: formatMoney(v.price),
        available: v.available,
        featured_image: v.featured_image || product.featured_image,
      };
      addToBuildSummary(productForSummary, img, variantOptionsText);
      closeVariantModal();
    }

    function closeVariantModal() {
      const overlay = document.getElementById('orpvb-variant-modal-overlay-' + sectionId);
      if (overlay) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
        if (modalOverlayOriginalParent) {
          modalOverlayOriginalParent.appendChild(overlay);
        }
      }
      variantModalProduct = null;
      variantModalSelectedVariant = null;
    }

    function initVariantModalEvents() {
      const overlay = container.querySelector('.orpvb-variant-modal-overlay');
      if (!overlay) return;
      const closeBtn = overlay.querySelector('.orpvb-variant-modal__close');
      const modalAddBtn = overlay.querySelector('.orpvb-variant-modal__add-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeVariantModal);
      if (modalAddBtn) {
        modalAddBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (!modalAddBtn.disabled) addModalProductToBuild();
        });
      }
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeVariantModal();
      });
    }

    function initHotspotEvents() {
      const hotspots = container.querySelectorAll('.orpvb-hero-hotspot');
      const popups = container.querySelectorAll('[data-hotspot-popup]');

      function closeAllPopups() {
        popups.forEach((p) => p.classList.remove('is-open'));
      }

      hotspots.forEach((hotspot) => {
        const wrap = hotspot.closest('.orpvb-hero-hotspot-wrap');
        const popup = wrap ? wrap.querySelector('[data-hotspot-popup]') : null;
        if (!popup) return;

        hotspot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const wasOpen = popup.classList.contains('is-open');
          closeAllPopups();
          if (!wasOpen) popup.classList.add('is-open');
        });
      });

      function updateHotspotVariant(popup, variant, data) {
        const priceEl = popup.querySelector('[data-hotspot-price]');
        const compareEl = popup.querySelector('[data-hotspot-compare]');
        const titleEl = popup.querySelector('[data-hotspot-variant-title]');
        const addBtn = popup.querySelector('.orpvb-hotspot-product-card__add');
        const imgLink = popup.querySelector('.orpvb-hotspot-product-card__img');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        const variantTitleText = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ') || 'One size';
        const isDefaultTitle = variantTitleText === 'Default Title';
        if (titleEl) {
          titleEl.textContent = isDefaultTitle ? '' : variantTitleText;
          titleEl.style.display = isDefaultTitle ? 'none' : '';
        }
        if (addBtn) {
          addBtn.dataset.variantId = String(variant.id);
          addBtn.dataset.price = String(variant.price);
          addBtn.dataset.priceFormatted = formatMoney(variant.price);
          addBtn.dataset.imageSrc = (variant.featured_image && variant.featured_image.src) || '';
          addBtn.dataset.variantOptions = isDefaultTitle ? '' : variantTitleText;
          addBtn.disabled = !variant.available;
        }
        if (imgLink && variant.featured_image && variant.featured_image.src) {
          const img = imgLink.querySelector('img');
          if (img) img.src = variant.featured_image.src;
        }
      }

      function findHotspotVariant(data, selectedByPosition) {
        if (!data || !data.variants || !data.variants.length) return null;
        return data.variants.find((v) => {
          return (selectedByPosition[1] == null || v.option1 === selectedByPosition[1]) &&
            (selectedByPosition[2] == null || v.option2 === selectedByPosition[2]) &&
            (selectedByPosition[3] == null || v.option3 === selectedByPosition[3]);
        }) || null;
      }

      popups.forEach((popup) => {
        const closeBtn = popup.querySelector('.orpvb-hotspot-popup__close');
        const addBtn = popup.querySelector('.orpvb-hotspot-product-card__add');
        const optionsWrap = popup.querySelector('[data-hotspot-options]');
        const scriptEl = popup.querySelector('script[data-hotspot-variants]');
        let hotspotData = null;
        if (scriptEl && scriptEl.textContent) {
          try {
            hotspotData = JSON.parse(scriptEl.textContent.trim());
          } catch (_) { }
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', () => popup.classList.remove('is-open'));
        }

        if (optionsWrap && hotspotData && hotspotData.variants && hotspotData.variants.length) {
          const valueBtns = optionsWrap.querySelectorAll('.orpvb-hotspot-option-value');
          valueBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const position = parseInt(btn.dataset.optionPosition, 10);
              const value = btn.dataset.value;
              const optionRow = btn.closest('.orpvb-hotspot-option');
              if (optionRow) {
                optionRow.querySelectorAll('.orpvb-hotspot-option-value').forEach((b) => {
                  b.classList.remove('is-selected');
                  b.setAttribute('aria-pressed', 'false');
                });
                btn.classList.add('is-selected');
                btn.setAttribute('aria-pressed', 'true');
              }
              const selectedByPosition = {};
              optionsWrap.querySelectorAll('.orpvb-hotspot-option').forEach((row) => {
                const pos = parseInt(row.dataset.optionPosition, 10);
                const selectedBtn = row.querySelector('.orpvb-hotspot-option-value.is-selected');
                if (selectedBtn) selectedByPosition[pos] = selectedBtn.dataset.value;
              });
              const variant = findHotspotVariant(hotspotData, selectedByPosition);
              if (variant) updateHotspotVariant(popup, variant, hotspotData);
            });
          });
        }

        if (addBtn) {
          addBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (addBtn.disabled) return;
            const product = {
              variant_id: parseInt(addBtn.dataset.variantId, 10),
              id: parseInt(addBtn.dataset.productId, 10),
              title: addBtn.dataset.title || '',
              price: parseInt(addBtn.dataset.price, 10) || 0,
              price_formatted: addBtn.dataset.priceFormatted || '$0.00',
              variant_options_text: addBtn.dataset.variantOptions || '',
            };
            const imgSrc = addBtn.dataset.imageSrc || '';
            addToBuildSummary(product, imgSrc);
            popup.classList.remove('is-open');
          });
        }

        popup.addEventListener('click', (e) => e.stopPropagation());
      });

      document.addEventListener('click', () => closeAllPopups());
    }

    function bindSummaryEvents() {
      if (!summaryList) return;
      summaryList.addEventListener('click', (e) => {
        const item = e.target.closest('.orpvb-build-summary__item');
        if (!item) return;
        const index = parseInt(item.dataset.index, 10);
        const action = e.target.dataset?.action;
        if (action === 'remove') {
          buildSummaryItems.splice(index, 1);
          updateSummaryUI();
          return;
        }
        if (action === 'qty-minus' && buildSummaryItems[index].quantity > 1) {
          buildSummaryItems[index].quantity -= 1;
          updateSummaryUI();
        }
        if (action === 'qty-plus') {
          buildSummaryItems[index].quantity += 1;
          updateSummaryUI();
        }
      });
    }

    function initProductTraySwiper() {
      if (productTraySwiper) {
        productTraySwiper.destroy(true, true);
        productTraySwiper = null;
      }
      const prev = container.querySelector('.orpvb-tray-nav--prev');
      const next = container.querySelector('.orpvb-tray-nav--next');
      const pv = Math.min(6, Math.max(2, productsPerView));
      productTraySwiper = new window.Swiper(trayEl, {
        slidesPerView: pv,
        spaceBetween: 12,
        freeMode: false,
        navigation: prev && next ? { nextEl: next, prevEl: prev } : undefined,
        breakpoints: {
          320: { slidesPerView: Math.min(2, pv) },
          640: { slidesPerView: Math.min(3, pv) },
          1024: { slidesPerView: pv },
        },
      });
    }

    function renderTraySlides(products, categoryName) {
      trayWrapper.innerHTML = '';
      currentProducts = products || [];
      if (trayTitleEl) {
        if (categoryName) {
          trayTitleEl.innerHTML = `<span class="orpvb-tray-title__prefix">SELECT YOUR</span><span class="orpvb-tray-title__category">${escapeHtml(categoryName).toUpperCase()}</span>`;
        } else {
          trayTitleEl.textContent = 'Select a category';
        }
      }

      if (!products || products.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'orpvb-tray-empty';
        empty.textContent = 'No products in this collection.';
        trayWrapper.appendChild(empty);
        initProductTraySwiper();
        return;
      }

      products.forEach((product, index) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide orpvb-tray-slide';
        slide.dataset.variantId = product.variant_id;
        slide.dataset.productId = product.id;
        slide.dataset.productIndex = index;
        const hasVariants = (product.variants_count || (product.variants && product.variants.length)) > 1;
        const imgSrc = product.featured_image && product.featured_image.src ? product.featured_image.src : '';
        const title = product.title || '';
        const priceFormatted = product.price_formatted || '$0.00';
        const showCompare = product.compare_at_price && product.compare_at_price > product.price;
        const compareFormatted = showCompare ? formatMoney(product.compare_at_price) : '';
        const priceBlock = showCompare
          ? `<span class="orpvb-tray-slide__price-compare">${escapeHtml(compareFormatted)}</span> <span class="orpvb-tray-slide__price-current">${escapeHtml(priceFormatted)}</span>`
          : `<span class="orpvb-tray-slide__price-current">${escapeHtml(priceFormatted)}</span>`;
        const variantBadge = hasVariants ? `<span class="orpvb-tray-slide__variant-badge">${(product.variants_count || product.variants.length)} options</span>` : '';
        const addBtnText = !product.available ? 'Out of stock' : hasVariants ? 'Select options' : 'Add';
        slide.innerHTML = `
          <div class="orpvb-tray-slide__inner">
            <div class="orpvb-tray-slide__img-wrap">
              ${imgSrc ? `<img class="orpvb-tray-slide__img" src="${imgSrc}" alt="${escapeHtml((product.featured_image && product.featured_image.alt) || title)}" loading="lazy">` : '<div class="orpvb-tray-slide__img" style="background:#eee;min-height:120px"></div>'}
              ${variantBadge}
            </div>
            <div class="orpvb-tray-slide__title">${escapeHtml(title)}</div>
            <div class="orpvb-tray-slide__price">${priceBlock}</div>
            <button type="button" class="orpvb-tray-slide__add" ${product.available ? '' : 'disabled'}>${addBtnText}</button>
          </div>
        `;
        trayWrapper.appendChild(slide);

        const addBtn = slide.querySelector('.orpvb-tray-slide__add');
        if (addBtn && product.available) {
          addBtn.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if (hasVariants) {
              openVariantModal(product, imgSrc);
            } else {
              addToBuildSummary(product, imgSrc);
            }
          });
        }

        function setActiveCard(activeSlide) {
          trayEl.querySelectorAll('.orpvb-tray-slide').forEach((s) => s.classList.remove('orpvb-tray-slide--active'));
          if (activeSlide) {
            activeSlide.classList.add('orpvb-tray-slide--active');
            trayEl.classList.add('orpvb-product-tray-swiper--has-active');
          } else {
            trayEl.classList.remove('orpvb-product-tray-swiper--has-active');
          }
        }
        slide.addEventListener('mouseenter', () => setActiveCard(slide));
        slide.addEventListener('mouseleave', () => setActiveCard(null));
        slide.addEventListener('focusin', () => setActiveCard(slide));
        slide.addEventListener('focusout', () => {
          const stillActive = trayEl.querySelector('.orpvb-tray-slide--active');
          if (!stillActive) setActiveCard(null);
        });
      });

      initProductTraySwiper();
      updateTraySelectedState();
    }

    function loadCategory(handle, categoryName) {
      const products = (collectionsData[handle] || []);
      renderTraySlides(products, categoryName);
    }

    categoryBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.collectionHandle;
        const name = btn.dataset.categoryName || '';
        categoryBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        loadCategory(handle, name);
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        buildSummaryItems = [];
        updateSummaryUI();
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', () => {
        if (buildSummaryItems.length === 0) return;
        const items = buildSummaryItems.map((i) => ({ id: i.variantId, quantity: i.quantity }));
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
          .then(({ ok, data }) => {
            if (ok) {
              window.location.href = '/checkout';
            } else {
              alert(data.description || 'Could not add items to cart.');
            }
          })
          .catch(() => alert('Could not add items to cart.'))
          .finally(() => { buyBtn.disabled = false; });
      });
    }

    bindSummaryEvents();
    updateSummaryUI();
    initVariantModalEvents();
    initHotspotEvents();

    ['.orpvb-tray-nav--prev', '.orpvb-tray-nav--next'].forEach((sel) => {
      const el = container.querySelector(sel);
      if (el) {
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
      }
    });

    if (heroEl && heroEl.querySelector('.swiper-slide') && window.Swiper) {
      heroSwiper = new window.Swiper(heroEl, {
        slidesPerView: 1,
        loop: heroEl.querySelectorAll('.swiper-slide').length > 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        navigation: {
          nextEl: heroEl.querySelector('.swiper-button-next'),
          prevEl: heroEl.querySelector('.swiper-button-prev'),
        },
        pagination: heroEl.querySelector('.swiper-pagination') ? { el: heroEl.querySelector('.swiper-pagination'), clickable: true } : false,
      });
    }

    const firstCategory = container.querySelector('.orpvb-category-btn[data-collection-handle]');
    if (firstCategory) {
      firstCategory.classList.add('is-active');
      loadCategory(firstCategory.dataset.collectionHandle, firstCategory.dataset.categoryName || '');
    } else {
      renderTraySlides([], '');
    }
  }

  function run() {
    if (typeof window.Swiper === 'undefined') {
      setTimeout(run, 100);
      return;
    }
    document.querySelectorAll(SECTION_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
